import type { SnapTolerance } from "@novorender/api";

import type { PickingSnapKey, StartPickingOptions } from "contexts/pickingSession/context";

// Per-type fallback tolerances, mirroring the PointLine measure tool ("pointAndCurve"). Used for a
// snap type enabled via `snapTo` when the caller did not provide an explicit `snapTolerance` value.
const DEFAULT_TOLERANCE: Record<PickingSnapKey, number> = {
    point: 0.03,
    edge: 0.03,
    segment: 0.02,
    edgeMidpoint: 0.03,
    arcCenter: 0.05,
};

// `snapTo` is an allowlist: every snap type is disabled by default and only the ones explicitly set
// to `true` are considered. The tolerance for an enabled type comes from `snapTolerance`, falling
// back to DEFAULT_TOLERANCE.
export function buildTolerance({
    snapTolerance,
    snapTo,
}: Pick<StartPickingOptions, "snapTolerance" | "snapTo">): SnapTolerance {
    const tolerance: SnapTolerance = {};
    if (snapTo) {
        for (const key of Object.keys(snapTo) as PickingSnapKey[]) {
            if (snapTo[key] === true) {
                tolerance[key] = snapTolerance?.[key] ?? DEFAULT_TOLERANCE[key];
            }
        }
    }
    return tolerance;
}
